import React, { useEffect, useState, useRef } from 'react';
//import { Link, useNavigate } from "react-router-dom";
import { httpRequest, httpAuthHeaders } from '../../../services/httpService';
import Modal from 'react-bootstrap/Modal';
// import Button from 'react-bootstrap/Button';
import Loader from '../../parts/Loader';
//import InputText from '../elements/InputText';
import RenderErrors from '../../elements/RenderErrors';
import ButtonGroupSelection from '../../elements/ButtonGroupSelection';
import store from '../../../services/store';
import helpers from '../../../services/helpers';
import { getApiData } from '../../../services/apiService';
import Swal from 'sweetalert2';
import { InputMask } from 'primereact/inputmask';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { SelectButton } from 'primereact/selectbutton';
import { InputTextarea } from 'primereact/inputtextarea';
import { Calendar } from 'primereact/calendar';
 
export default function CashFlowTransactionForm ({
        reference_id = '', 
        showModal = false, 
        closeModal, 
        handleSave, 
        title="Transaction",
        src="transactions",
        index="",
        member_data={},
        is_show = false, 
    }){
    let default_data = {
        "id": "",
        "type": "expense",
        "description":"",
        "amount":"",
        "flag":"new",
        "category_id": "",
        "transaction_date": new Date(),
        "transaction_date_format": new Date(),
        "account_id": 1,
        "is_locked": 0
    }
    const toast = useRef(null);
    const [loading, setLoading] = useState(0);
    const [notice, setNotice] = useState('');
    const [form_data, setFormData] = useState(default_data);
    const [categories, setCategories] = useState([]);
    const [form_loaded, setFormLoaded] = useState(0);
    const [errors, setErrors] = useState([]);
   
    useEffect(() => {
        if(showModal && reference_id){
            fetchData()
        }
        else if(showModal){
            setFormData(default_data)
            fetchCategories()
        }
    }, [showModal]);
   
    useEffect(() => {
        setErrors([])
    }, [form_data]);
   
    useEffect(() => {
        if(showModal){
            fetchCategories()
        }
    }, [form_data.type]);
    

    function fetchData(){
        if(!reference_id){
            return
        }
        const url = helpers.createUrl(`V1/cashflow/transactions/${reference_id}`)

        setLoading(1)
        httpRequest(url, "GET", {}, true)
        .then((res) => {
            let items = res;
            items.transaction_date_format = new Date(res.transaction_date)
            
            setFormData(items)
            fetchCategories()
            setLoading(0)
            setFormLoaded(1)
        })
        .catch((err) => {
            setLoading(0)
            setFormLoaded(0)

            Swal.fire({
                //title: err.message,
                text: err.message,
                icon: "error",
                confirmButtonText: "OK",
            })
            .then((result) => {
                if (result.isConfirmed) {
                    
                }
            })
        }); 
    }

    function fetchCategories(){
        const url = helpers.createUrl(`V1/cashflow/categories?type=${form_data.type}`)
        setLoading(1)
        httpRequest(url, "GET", {}, true)
        .then((res) => {
            setCategories(res)
            setLoading(0)
            setFormLoaded(1)
        })
        .catch((err) => {
            setLoading(0)
            setFormLoaded(0)

            Swal.fire({
                //title: err.message,
                text: err.message,
                icon: "error",
                confirmButtonText: "OK",
            })
            .then((result) => {
                if (result.isConfirmed) {
                    
                }
            })
        }); 
    }
    
    function inputChange(e,) {
        let { value, name } = e.target;

        if (e.target.type === "checkbox") {
            value = 0;
            
            if (e.target.checked) value = 1;
        }

        let new_state = { [name]: value }

        if(name === 'type'){
            new_state.category_id = ''
        }
        if(name === 'transaction_date'){
            new_state.transaction_date = helpers.formatDate(value)
            new_state.transaction_date_format = value
        }

        setFormData({ ...form_data, ...new_state });
    }

    function validateForm(){
        let new_errors = {...errors}
        let variant_errors = 0;

        if(!form_data.name){
            new_errors['name'] = ['The name field is required.']
        }
        else{
            delete new_errors['name'];
        }

        if(!form_data.relationship){
            new_errors['relationship'] = ['The relationship field is required.']
        }
        else{
            delete new_errors['relationship'];
        }

        if(!form_data.gender){
            new_errors['gender'] = ['The gender field is required.']
        }
        else{
            delete new_errors['gender'];
        }

        if(form_data.amount === null || form_data.amount === undefined || form_data.amount === ""){
            new_errors['amount'] = ['The amount field is required.']
        }
        else{
            delete new_errors['amount'];
        }

        setErrors(new_errors);

        return new_errors;
    }

    // function handleSubmit(e) {
    //     const validate = validateForm();
    //     if(Object.keys(validate).length){
    //         toast.current.show({severity:'error', detail:'Please complete all required fields in the form.', life: 5000});
    //         return
    //     }

    //     closeModal(0);
    //     let form_data = {...form_data}
    //     if(reference_id){
    //         form_data.flag = 'edit'
    //     }

    //     handleSave(form_data, index)
        
    // }

    function handleSubmit(e) {
        let url = helpers.createUrl(`V1/cashflow/transactions/create`)
        if(reference_id && form_loaded){
            url = helpers.createUrl(`V1/cashflow/transactions/${reference_id}`)
        }

        httpRequest(url, 'POST', {
            postdata: form_data,
        }, true)
            .then((res) => {
                form_data.id = res.id
                setLoading(0)
                toast.current.show({severity:'success', detail:res.message, life: 20000});

                closeModal(0);
                handleSave(form_data)
            })
            .catch((err) => {
                console.log(err)
                setLoading(0)
                
                if(err.data){
                    setErrors( err.data );
                }else{
                    setErrors([])
                }

                toast.current.show({severity:'error', detail:err.message, life: 5000});
            }); 
    }

    function handleClose(e) {
        reset();
        closeModal(0);
    }

    function reset(){
        setFormData([])
        setNotice('')
    }

    const footerContent = (
        <div>
            <Button 
                label="Save" 
                className='rounded' 
                icon="fas fa-check" 
                onClick={(e) => handleSubmit(1)} 
                disabled={form_data?.is_locked ? true : false}
                autoFocus 
            />
        </div>
    );

    return (
        <>
            <Toast ref={toast} position="top-center" />
            <Dialog 
                visible={showModal} 
                position="top" 
                header={reference_id ? 'Transaction': 'New Transaction'} 
                style={{ 
                    width: '50vw'
                }} 
                breakpoints={{ 
                    '960px': '75vw', // On Tablet (screen < 960px), use 75% width
                    '641px': '95vw'  // On Mobile (screen < 641px), use 95% width
                }}
                onHide={handleClose} 
                footer={footerContent}
            >
                <Loader isLoading={loading}/>
                <div>
                    <div className="row">
                        <div className="col-12 mt-2 form-group">
                            <SelectButton 
                                name='type' 
                                value={form_data.type}
                                onChange={inputChange}
                                options={[
                                    {"value":"expense","label": "Expense"},
                                    {"value":"income","label": "Income"},
                                ]}
                                optionLabel="label"
                                optionValue="value"
                                allowEmpty={false}
                                disabled={form_data?.is_locked ? true : false}
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="type" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                        <div className="col-12 form-group">
                            <label>Category<span className="text-danger">*</span></label>
                            <Dropdown  
                                name='category_id'
                                value={parseInt(form_data.category_id)} 
                                onChange={(e) =>
                                    setFormData(prev => ({
                                        ...prev,
                                        'category_id': e.value
                                    }))
                                } 
                                options={categories} 
                                optionLabel="name" 
                                optionValue="id" 
                                placeholder="Select Category" 
                                className="w-100" 
                                checkmark={true} 
                                highlightOnSelect={false}
                                filterInputAutoFocus={true}
                                disabled={form_data?.is_locked ? true : false}
                                appendTo="self"
                                showClear
                                filter 
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="category_id" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 col-lg-6 form-group">
                            <label>Date<span className="text-danger">*</span></label>
                            <Calendar 
                                name="transaction_date"  
                                value={form_data.transaction_date_format} 
                                onChange={inputChange} 
                                className='w-100' 
                                dateFormat="yy-mm-dd" 
                                disabled={form_data?.is_locked ? true : false}
                                icon={() => <i className="far fa-calendar"></i>} 
                                appendTo="self"
                                showIcon  
                                panelStyle={{ zIndex: 999999 }} // 👈 Forces this individual panel to sit on top of the Dial
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="transaction_date" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                        <div className="col-12 col-lg-6 form-group">
                            <label>Amount<span className="text-danger">*</span></label>
                            <InputNumber
                                id="amount" 
                                name="amount" 
                                value={form_data.amount}
                                placeholder="Amount"
                                tagClass="form-control mb-0"
                                onValueChange={inputChange}
                                //mode="currency" 
                                //currency="PHP" 
                                locale="en-US" 
                                prefix="₱ " 
                                maxFractionDigits={2}
                                className='w-100'
                                disabled={form_data?.is_locked ? true : false}
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="amount" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 form-group">
                            <label>Description<span className="text-danger">*</span></label>
                            <InputTextarea
                                id="description" 
                                name="description" 
                                value={form_data.description}
                                className="w-100 form-control"
                                maxLength={1500}
                                rows={5}
                                onChange={inputChange}
                                placeholder="Description"
                                disabled={form_data?.is_locked ? true : false}
                            />
                            <RenderErrors 
                                errors={errors} 
                                name="amount" 
                                className="text-danger"
                                style={{fontSize: '.9rem'}}
                            />
                        </div>
                    </div>
                </div>
            </Dialog>
        </>
    )
}